export const LOG_EVENT_NAME = {
  lnbTabClick: 'lnb tab click',
  lnbToggle: 'lnb toggle',
};

export const LNB_STATE = {
  open: 'open',
  folded: 'folded',
};
